import { Box, Button, Typography, } from '@mui/material';
import React from 'react';
import styled from '@emotion/styled';


const TitleHeading = styled(Typography)`
font-size: 80px;
 line-height: 1;
 margin-bottom: 1rem;
 max-width: 1000px;
 font-family: Bold !important;
   @media(max-width: 1200px){
        font-size: 60px ;
    }
@media(max-width: 599px){
        font-size: 40px;

    }
  
`


const TitleUpper = (props) => {
  return ( 
  <TitleHeading  {...props} > {props.children} </TitleHeading>
  );
}
 
export default TitleUpper;